<template>
  <a-modal
    ref="authRole"
    :title="modalTitle"
    :width="900"
    :visible="visible"
    :confirm-loading="submitLoading"
    @cancel="close"
    @ok="confirm"
  >
    <div class="page-header-content">
      <a-card :bordered="false" class="content">
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="8" :sm="24">
                <a-form-item label="用户名称">
                  <a-input v-model="queryParam.userName" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="手机号码">
                  <a-input v-model="queryParam.phoneNumber" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-table
          :loading="loading"
          size="small"
          rowKey="id"
          :columns="columns"
          :data-source="list"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :scroll="{ y: tableHeight }"
          :pagination="false">
          <span slot="status" slot-scope="text, record">
            <dict-tag :options="statusOptions" :value="record.status"/>
          </span>
          <span slot="createTime" slot-scope="text, record">
            {{ parseTime(record.createTime) }}
          </span>
        </a-table>
      </a-card>
    </div>
  </a-modal>
</template>

<script>

import { getAuthUser, updateAuthUser } from '@/api/system/role'

export default {
  name: 'SelectUser',
  props: {
    statusOptions: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      list: [],
      role: {},
      roleId: null,
      selectedRowKeys: [],
      userIds: [],
      tableHeight: document.documentElement.scrollHeight - 500 + 'px',
      loading: false,
      submitLoading: false,
      visible: false,
      queryParam: {
        userName: undefined,
        phoneNumber: undefined
      },
      columns: [
        {
          title: '用户名称',
          dataIndex: 'userName',
          align: 'center'
        },
        {
          title: '用户昵称',
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '手机',
          dataIndex: 'phoneNumber',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  computed: {
    modalTitle () {
      const roleName = this.role && this.role.roleName ? this.role.roleName : ''
      return roleName ? `分配用户 - ${roleName}` : '分配用户'
    }
  },
  methods: {
    getList () {
      if (!this.roleId) {
        return
      }
      this.loading = true
      getAuthUser(this.roleId, this.queryParam).then(res => {
        if (Number(res.code) === 20001) {
          this.list = res.data.users || []
          this.role = res.data.role || {}
          const allocatedIds = (res.data.allocatedUsers || []).map(item => item.id)
          this.userIds = allocatedIds
          this.selectedRowKeys = allocatedIds
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    close () {
      this.visible = false
      this.selectedRowKeys = []
      this.userIds = []
      this.list = []
      this.role = {}
      this.roleId = null
    },
    handleAuthUser (row) {
      this.roleId = row.id
      this.visible = true
      this.queryParam = {
        userName: undefined,
        phoneNumber: undefined
      }
      this.getList()
    },
    confirm () {
      this.submitLoading = true
      updateAuthUser({ roleId: this.roleId, userIds: this.userIds }).then(res => {
        this.$message.success(res.message || '授权成功')
        this.visible = false
        this.$emit('ok')
      }).finally(() => {
        this.submitLoading = false
      })
    },
    handleQuery () {
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        userName: undefined,
        phoneNumber: undefined
      }
      this.handleQuery()
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.userIds = selectedRowKeys
    }
  }
}
</script>
